import { useState, useEffect } from "react";
import { VALIDATION_ERROR } from "../app/errors";
import { ErrorWithString } from "./RegularComponents";

const DateSelectionComponentsForm = (props) => {
  const { id, dateComponents, showValidationError, disableFutureDate } = props;
  const {day, month, year} = dateComponents

  const [dayComponent, setDayComponent] = useState(day ?? "");
  const [monthComponent, setMonthComponent] = useState(month ?? "");
  const [yearComponent, setYearComponent] = useState(year ?? "");

  const [showDateValidationError, setDateShowValidationError] = useState(showValidationError);

  const [dateError, setDateError] = useState(VALIDATION_ERROR.NO_ERROR);

  useEffect(() => {
    setDateShowValidationError(showValidationError);
  }, [showValidationError, setDateShowValidationError])

  useEffect(() => {
    const {day, month, year} = dateComponents
    setDayComponent(day);
    setMonthComponent(month);
    setYearComponent(year);
  }, [
    dateComponents,
  ]);

  const isDateValid = () => {
    if (showDateValidationError) {
      return dateError === VALIDATION_ERROR.NO_ERROR;
    }

    return true;
  };

  const dateErrorString = () => {
    switch (dateError) {
      case VALIDATION_ERROR.EMPTY:
        return "Enter a date";
      case VALIDATION_ERROR.DATE_INVALID:
      case VALIDATION_ERROR.DATE_DAY_INVALID:
      case VALIDATION_ERROR.DATE_MONTH_INVALID:
      case VALIDATION_ERROR.DATE_YEAR_INVALID:
        return "Enter a valid date";
      case VALIDATION_ERROR.DATE_IN_FUTURE:
        return "Date can't be in future";
      default:
        return "";
    }
  };

  const onInputChange = (e) => {
    let updateDay = dayComponent;
    let updateMonth = monthComponent;
    let updateYear = yearComponent;

    setDateError(VALIDATION_ERROR.NO_ERROR);
    
    if (e.target.id.indexOf("day") !== -1) {
      updateDay = +e.target.value;

      // set the error string
      if (!updateDay || updateDay < 1 || updateDay > 31) {
        setDateError(VALIDATION_ERROR.DATE_DAY_INVALID);
      }

      setDayComponent(e.target.value);
    } else if (e.target.id.indexOf("month") !== -1) {
      updateMonth = +e.target.value;

      // set the error string
      if (!updateMonth || updateMonth < 1 || updateMonth > 31) {
        setDateError(VALIDATION_ERROR.DATE_MONTH_INVALID);
      }

      setMonthComponent(e.target.value);
    } else if (e.target.id.indexOf("year") !== -1) {
      updateYear = +e.target.value;
      
      // set the error string
      if (!updateYear || updateYear < 1 || updateYear > 31) {
        setDateError(VALIDATION_ERROR.DATE_YEAR_INVALID);
      }

      setYearComponent(e.target.value);
    }

    if(disableFutureDate) {
      const dateObj = new Date(updateYear, updateMonth - 1, updateDay);
        if (dateObj.getTime() > Date.now()) {
          setDateError(VALIDATION_ERROR.DATE_IN_FUTURE);
        }
    }

    if (props.onDateComponentsChange) {
      props.onDateComponentsChange({
        day : updateDay,
        month : updateMonth,
        year : updateYear
      })
    }
  };

  return (
    <>
      {!isDateValid() && (
        <span
          id={id + "-date-error"}
          className="ns-error-message field-validation-error"
        >
          {ErrorWithString(dateErrorString())}
        </span>
      )}
      <div className="ns-fieldset">
        <fieldset aria-describedby="date-entry">
          {/* <legend className="ns-fieldset__legend noBorder label">
                    Date
                </legend> */}
          <div className="row">
            <div className="col-auto">
              <label htmlFor={id + "-day-input"}>DD</label>
              <input
                disabled={props.readOnly}
                className={
                  "fw-2" + (!isDateValid() ? " ns-input--error" : " ns-input")
                }
                id={id + "-day-input"}
                pattern={"[0-9]*"}
                inputMode="numeric"
                name={id + "-day-input"}
                value={dayComponent}
                onInput={onInputChange}
                type={"text"}
              />
            </div>
            <div className="col-auto">
              <label htmlFor={id + "-month-input"}>MM</label>
              <input
                disabled={props.readOnly}
                className={
                  "fw-2" + (!isDateValid() ? " ns-input--error" : " ns-input")
                }
                name={id + "-month-input"}
                id={id + "-month-input"}
                pattern={"[0-9]*"}
                inputMode="numeric"
                value={monthComponent}
                onInput={onInputChange}
                type={"text"}
              />
            </div>
            <div className="col-auto">
              <label htmlFor={id + "-year-input"}>YYYY</label>
              <input
                disabled={props.readOnly}
                className={
                  "fw-4" + (!isDateValid() ? " ns-input--error" : " ns-input")
                }
                name={id + "-year-input"}
                id={id + "-year-input"}
                pattern={"[0-9]*"}
                inputMode="numeric"
                value={yearComponent}
                onInput={onInputChange}
                type={"text"}
              />
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};

export default DateSelectionComponentsForm;
